import DashboardLayout from "../layouts/DashboardLayout";
import ProjectsList from "../components/ ProjectsList";
export default function Dashboard() {
  return (
    <DashboardLayout>
      <ProjectsList />
    </DashboardLayout>
  );
}
